import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloseDialog } from 'src/app/general/services/dialog.service';
import { Consumer } from 'src/app/general/interfaces/functions';
import { ReprocessOrderPaymentDialogData, ReprocessOrderPaymentDialogComponent } from './reprocess-order-payment-dialog.component';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public getReprocessOrderPaymentData(): void {
//   this.reprocessOrderPaymentDialogService.openDialog(
//     /* onUpdate */ outputDialogData => {
//       console.log(outputDialogData);
//     }
//   );
// }

// ----------------------------------------------------------------------------

@Injectable({
  providedIn: 'root',
})
export class ReprocessOrderPaymentDialogService {

  constructor(private dialog: MatDialog) { }

  public openDialog(onUpdate: Consumer<ReprocessOrderPaymentDialogData>) : CloseDialog {
    const dialogRef = this.dialog.open(ReprocessOrderPaymentDialogComponent, {
      data: {},
      autoFocus: true,
      hasBackdrop: true,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(outputDialogData => {
      if (outputDialogData) {
        onUpdate(outputDialogData);
      }
    });

    return () => dialogRef.close();
  }
}
